// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from './context/AuthContext';

// Core Pages
import ScrollToTop from "./pages/ScrollToTop";
import Navbar from './components/Navbar';
import PageMeta from './components/PageMeta';
import TestSeries from "./pages/TestSeries";
import ContactUs from "./pages/ContactUs";
import Login from './pages/Login';
import Profile from "./pages/Profile";
import Signup from './pages/Signup';
import Privacy from "./components/privacy";
import Terms from "./components/terms-condition";
import Refund from "./components/cancel_refund";
import Shipping from "./components/shipping_policy";

import './App.css';
import UserManagementDashboard from './pages/UserManagementDashboard';
import ExamInfo from './pages/ExamInfo';

// Generic Sales & Admin
import TestSeriesDetailPage from './pages/test-series/TestSeriesDetailPage';
import PurchasedTestsPage from './pages/test-series/PurchasedTestsPage';
import PurchasedTestDetailPage from './pages/test-series/PurchasedTestDetailPage';
import PremiumTestPage from './pages/test-series/PremiumTestPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminInvoices from './pages/admin/AdminInvoices';

// Category Hub Pages
import JeePremiumPage from './pages/test-series/JeePremiumPage';
import NeetPremiumPage from './pages/test-series/NeetPremiumPage';

// Main Free Test Landing Pages
import PyqTestSeriesPage from './pages/TestSeries/PyqTestSeriesPage';
import FreeJEETestSeries from "./pages/TestSeries/FreeJEETestSeries";
import FreeAdvTestSeries from "./pages/TestSeries/FreeAdvTestSeries";
import FreeNEETTestSeries from "./pages/TestSeries/FreeNEETTestSeries";

// --- Free JEE Mains PYQ Imports ---
// Removed individual JEE PYQ test imports

// --- Free NEET PYQ Imports ---
// Removed individual NEET PYQ test imports

// --- Free Adv Import ---
// Removed individual JEE Adv test imports

// Added consolidated free test imports
import FreeJEETest from './pages/TestSeries/freejeetest/FreeJEETest';
import FreeNEETTest from './pages/TestSeries/freeneettest/FreeNEETTest';
import FreeAdvTest from './pages/TestSeries/freeadvtest/FreeAdvTest';

// Keep the existing test1 for JEE Advanced (it's already perfect!)
//import ADVPYQTesttest1 from "./pages/freeadvtest/test1";

function App() {
  return (
    <AuthProvider>
      <Router>
        <PageMeta />
        <Navbar />
        <ScrollToTop />
        <Routes>
          {/* Main Landing Routes */}
          <Route path="/" element={<TestSeries />} />
          <Route path="/test-series" element={<TestSeries />} />

          {/* Auth & Support Routes */}
          <Route path="/inquiry-now" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/shipping-policy" element={<Shipping />} />


          {/* Exam Info Page */}
          <Route path="/exam-guide" element={<ExamInfo />} />

          {/* Dedicated Category Landing Pages */}
          <Route path="/test-series/pyq" element={<PyqTestSeriesPage />} />
          <Route path="/test-series/jee-premium" element={<JeePremiumPage />} />
          <Route path="/test-series/neet-premium" element={<NeetPremiumPage />} />

          {/* 🚨 THE SMART DYNAMIC ROUTE FOR ALL PAID SERIES 🚨 */}
          {/* All navbar premium links go to TestSeriesDetailPage (purchase page) */}
          <Route path="/test-series/:category/:productId" element={<TestSeriesDetailPage />} />

          {/* Admin Dashboard Layout */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="user-management" element={<UserManagementDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="invoices" element={<AdminInvoices />} />  
          </Route>

          {/* 🎓 PURCHASED TESTS PAGE */}
          <Route path="/purchased-tests" element={<PurchasedTestsPage />} />
          <Route path="/purchased-tests/:courseId" element={<PurchasedTestDetailPage />} />
          <Route path="/premium-test/:courseId/:testId" element={<PremiumTestPage />} />

          {/* Landing pages for Free categories */}
          <Route path="/test-series/pyq/jeemains" element={<FreeJEETestSeries />} />
          <Route path="/test-series/pyq/jeeadv" element={<FreeAdvTestSeries />} />
          <Route path="/test-series/pyq/neet" element={<FreeNEETTestSeries />} />
         
          {/* 🎯 DYNAMIC ROUTES */}
          <Route path="/test-series/pyq/jeemains/:testId" element={<FreeJEETest />} />
          <Route path="/test-series/pyq/neet/:testId" element={<FreeNEETTest />} />
          <Route path="/test-series/pyq/jeeadv/:testId" element={<FreeAdvTest />} />
          
          {/* Keep the working JEE Advanced test 
          <Route path="/test-series/pyq/jeeadv/test1" element={<ADVPYQTesttest1 />} /> */}
          
          {/* Remove all these old individual test routes */}
          {/* <Route path="/test-series/pyq/jeemains/22jan2025shift1" element={<JEEPYQTest22jan2025shift1 />} /> */}
          {/* <Route path="/test-series/pyq/jeemains/23jan2025shift1" element={<JEEPYQTest23jan2025shift1 />} /> */}
          {/* <Route path="/test-series/pyq/neet/neet2022q1" element={<NEETTest2022Q1 />} /> */}
          {/* <Route path="/test-series/pyq/neet/neet2022r1" element={<NEETTest2022R1 />} /> */}
          {/* ...all other individual JEE/NEET test routes... */}

          {/* User Management Dashboard (superadmin/admin with access) */}
        
        </Routes>
        <Analytics />
      </Router>
    </AuthProvider>
  );
}

export default App;